/** @format */

import { Pipe, PipeTransform } from '@angular/core';

import { SafeUrl } from '@angular/platform-browser';

@Pipe({
  name: 'dcsgListSubheading',
  standalone: true,
})
export class ListSubheadingPipe implements PipeTransform {
  public transform(value: any, isPublicList, isListCard, recommendedListDescription): SafeUrl {
    if (isListCard && recommendedListDescription) {
      return recommendedListDescription;
    } else if (!isListCard && recommendedListDescription) {
      return `${value} items - ${recommendedListDescription}`;
    } else if (value === null || value === undefined) {
      return '0 items - Start Saving!';
    } else if (value === 0 && !isPublicList) {
      return '0 items - Start Saving!';
    }

    return value === 1 ? '1 item' : `${value} items`;
  }
}
